module.exports = {"130825001":"安州街道","130825100":"苔山镇","130825101":"韩麻营镇","130825102":"中关镇","130825103":"七家镇","130825104":"汤头沟镇","130825105":"张三营镇","130825106":"唐三营镇","130825107":"蓝旗镇","130825108":"步古沟镇","130825109":"郭家屯镇","130825110":"茅荆坝镇","130825200":"荒地乡","130825201":"章吉营乡","130825203":"尹家营满族乡","130825204":"庙子沟蒙古族满族乡","130825205":"偏坡营满族乡","130825206":"山湾乡","130825207":"八达营蒙古族乡","130825208":"太平庄满族乡","130825209":"旧屯满族乡","130825210":"西阿超满族蒙古族乡","130825212":"碱房乡","130825213":"韩家店乡","130825214":"湾沟门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130825.json
// module id = 294
// module chunks = 0